export const FULL_CATALOG = 'FULL_CATALOG'
export const SELECTED_ENTITIES = 'SELECTED_ENTITIES'

export const control_options = [{
    label: 'Все товары',
    value: FULL_CATALOG,
}, {
    label: 'Выбрать...',
    value: SELECTED_ENTITIES,
},]
